export default "__VITE_ASSET__CK6Kcd_T__"